import { render, staticRenderFns } from "./ReworkedNavigationDrawer.vue?vue&type=template&id=4ab78b4a&scoped=true&"
import script from "./ReworkedNavigationDrawer.vue?vue&type=script&lang=js&"
export * from "./ReworkedNavigationDrawer.vue?vue&type=script&lang=js&"
import style0 from "./ReworkedNavigationDrawer.vue?vue&type=style&index=0&id=4ab78b4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab78b4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VList,VListItem,VListItemContent,VTextField})
